<div
  class="call-group mat-elevation-z12"
  fxLayout="column"
  @fadePopup
  [ngStyle]="{ 'z-index': 1000 }">
  <div
    class="call-header"
    fxLayout="row"
    fxLayoutAlign="space-between center"
    cdkDragHandle
    #callHeader>
    <div fxLayout="column" fxLayoutAlign="flex-start">
      <span class="main-text">{{ popup.data.busCode }}</span>
      <span class="subtext">{{ formattedTime }}</span>
    </div>

    <div fxLayout="row" class="actions">
      <span
        class="material-icons pointer call-icon on"
        *ngIf="micOn"
        (click)="toggleMic()"
        >mic</span
      >
      <span
        class="material-icons pointer call-icon off"
        *ngIf="!micOn"
        (click)="toggleMic()"
        >mic_off</span
      >
      <span
        class="material-icons pointer call-icon bg-off"
        (click)="closeEvent.emit()"
        >call_end</span
      >
    </div>
  </div>
  <div class="call-body"></div>
</div>
